import * as components from './components';

export default [
  {
    path: '/masters/resolution-codes',
    component: components.ResolutionCodeList,
    name: 'resolutionCodeList',
    meta: { admin: true }
  },
  {
    path: '/masters/resolution-code-categories',
    component: components.ResolutionCodeCategoryList,
    name: 'resolutionCodeCategoryList',
    meta: { admin: true }
  }
];


// WEBPACK FOOTER //
// ./ClientApp/app/masters/resolutioncodes/routes.js